import React, { FunctionComponent, useCallback, useState } from 'react'
import { useAddProductToSale } from '../AddProductToSale/useAddProductToSale'
import {
  QuickKey,
  QuickKeyBlank,
  QuickKeyFolder,
  QuickKeyKey,
} from './utils/qk-types'
import { QuickKeyNodeType } from './utils/qk.constants'
import { useQuickKeysLayout } from './useQuickKeysLayout'
import { QKRoot } from './nodes/QKRoot'
import { NoQuickKeys } from './NoQuickKeys'
import { QuickKeysKeyboardNav } from './QuickKeysKeyboardNav'
import { getFirstChild } from './quickKeyUtils'
import { getProductDetails } from './utils/qk-layout'

export const QuickKeys: FunctionComponent = () => {
  const [currentRoot, setCurrentRoot] = useState<QuickKeyFolder | null>(null)
  const [focussed, setFocussed] = useState<QuickKeyFolder | QuickKeyKey | null>(
    null
  )
  const layout = useQuickKeysLayout()
  const { addProductToSale } = useAddProductToSale()

  const setQuickKeyFocus = useCallback(
    (quickKey: QuickKeyFolder | QuickKeyKey | QuickKeyBlank | null) => {
      if (quickKey?.type === QuickKeyNodeType.BLANK) {
        setFocussed(null)
        return
      }
      setFocussed(quickKey)
    },
    []
  )

  const selectQuickKey = useCallback(
    (quickKey: QuickKey | null) => {
      switch (quickKey?.type) {
        case QuickKeyNodeType.FOLDER:
          setCurrentRoot(quickKey)
          setFocussed(getFirstChild(quickKey) || null)
          break
        case QuickKeyNodeType.QUICK_KEY:
          addProductToSale(getProductDetails(quickKey))
          break
        default:
          setCurrentRoot(null)
      }
    },
    [addProductToSale]
  )

  if (!layout) {
    return <NoQuickKeys />
  }

  return (
    <QuickKeysKeyboardNav
      className="wr-quick-keys wr-workspace-module wr-workspace-module--fit-container"
      layout={layout}
      currentRoot={currentRoot}
      focussed={focussed}
      setFocussed={setQuickKeyFocus}
      setCurrentRoot={setCurrentRoot}
      selectQuickKey={selectQuickKey}
    >
      <QKRoot
        quickKey={currentRoot || layout}
        setRoot={setCurrentRoot}
        setFocus={setQuickKeyFocus}
        focussed={focussed}
        selectQuickKey={selectQuickKey}
      />
    </QuickKeysKeyboardNav>
  )
}
